module.exports = __webpack_public_path__ + "img/powered_bgo.93ab2aa7.png";